module.exports = __webpack_public_path__ + "static/media/userBackground.84295f2e.jpeg";